module.exports = __webpack_public_path__ + "static/assets/60a81f1554a7f2498a4435c68b68b27b.svg";